export default {
  survey: null
}
